"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFormTitle = exports.StyledFormSubHeader = exports.StyledFormItemWrapper = exports.StyledFormItemLabel = exports.StyledFormItemInputContainerCol = exports.StyledFormItemInputContainer = exports.StyledFormItemExtra = exports.StyledFormCaption = exports.StyledForm = void 0;
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _Styled = _interopRequireDefault(require("../Typography/Styled"));
var _StyledButton = _interopRequireDefault(require("../Button/StyledButton"));
var _StyledDivider = require("../Divider/StyledDivider");
var _Grid = require("../Grid");
var _col = require("../Grid/col");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledFormItemWrapper = exports.StyledFormItemWrapper = (0, _ykbStyledComponents.default)(_Grid.Col).withConfig({
  componentId: "ykb-ui__sc-1xyh3og-0"
})(["padding-bottom:", ";padding-left:", ";padding-right:", ";", " ", ""], function (props) {
  return props.theme.form.paddingBottom ? props.theme.form.paddingBottom : props.theme.form.padding;
}, function (props) {
  return props.theme.form.paddingLeft;
}, function (props) {
  return props.theme.form.paddingRight;
}, function (props) {
  return props.hidden && (0, _ykbStyledComponents.css)(["display:none;"]);
}, function (props) {
  return props.layout === 'vertical' && (0, _ykbStyledComponents.css)(["vertical-align:top;"]);
});
var StyledFormItemLabel = exports.StyledFormItemLabel = _ykbStyledComponents.default.label.withConfig({
  componentId: "ykb-ui__sc-1xyh3og-1"
})(["font-weight:", ";padding-bottom:", ";color:", ";display:inline-block;font-size:", ";", ";&:after{content:'\\00a0';display:inline-block;}", ""], function (props) {
  return props.theme.form.label.fontWeight;
}, function (props) {
  return props.theme.form.label.paddingBottom;
}, function (props) {
  return props.theme.form.label.color;
}, function (props) {
  return props.theme.form.label.fontSize;
}, function (props) {
  return props.theme.mixins.clearFix(_ykbStyledComponents.css);
}, function (props) {
  return props.viewMode && (0, _ykbStyledComponents.css)(["font-weight:", ";"], function (props) {
    return props.theme.form.viewMode.fontWeight;
  });
});
var StyledFormItemInputContainer = exports.StyledFormItemInputContainer = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1xyh3og-2"
})(["position:relative;", ""], function (props) {
  return props.flexGroup && (0, _ykbStyledComponents.css)(["display:flex;gap:10px;> *{margin:0px;}"]);
});
var StyledFormItemInputContainerCol = exports.StyledFormItemInputContainerCol = (0, _ykbStyledComponents.default)(_Grid.Col).withConfig({
  componentId: "ykb-ui__sc-1xyh3og-3"
})(["position:relative;"]);
var verticalForm = (0, _ykbStyledComponents.css)([""]);
var horizontalForm = (0, _ykbStyledComponents.css)([""]);
var StyledFormItemExtra = exports.StyledFormItemExtra = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1xyh3og-4"
})(["padding-top:4px;"]);
var StyledForm = exports.StyledForm = _ykbStyledComponents.default.form.withConfig({
  componentId: "ykb-ui__sc-1xyh3og-5"
})(["margin-top:", ";", " ", "{margin-bottom:0px !important;}"], function (props) {
  return props.theme.form.padding;
}, function (props) {
  return props.$layout === 'vertical' ? verticalForm : horizontalForm;
}, _col.StyledCol);
var StyledFormCaption = exports.StyledFormCaption = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1xyh3og-6"
})(["padding:0;", "{display:inline-block;vertical-align:middle;margin:0px;color:", ";}", "{margin-bottom:0px;}.extra{display:inline-block;vertical-align:middle;margin-left:", ";", "{color:", ";.text{margin-left:3px;font-weight:", ";}}}hr{padding:0px;}"], _Styled.default, function (props) {
  return props.theme.form.caption.color;
}, _StyledDivider.StyledDivider, function (props) {
  return props.theme.form.padding;
}, _StyledButton.default, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.form.extra.buttonTextWeight;
});
var StyledFormTitle = exports.StyledFormTitle = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1xyh3og-7"
})(["padding:", " 0;", "{display:inline-block;vertical-align:middle;margin:0px;color:", ";}.extra{display:inline-block;vertical-align:middle;margin-left:", ";", "{color:", ";.text{margin-left:3px;font-weight:", ";}}}"], function (props) {
  return props.theme.form.padding;
}, _Styled.default, function (props) {
  return props.theme.form.caption.color;
}, function (props) {
  return props.theme.form.padding;
}, _StyledButton.default, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.form.extra.buttonTextWeight;
});
var StyledFormSubHeader = exports.StyledFormSubHeader = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1xyh3og-8"
})(["", "{display:inline-block;vertical-align:middle;margin:0px;color:", ";}.extra{display:inline-block;vertical-align:middle;margin-left:", ";", "{color:", ";.text{margin-left:3px;font-weight:", ";}}}"], _Styled.default, function (props) {
  return props.theme.form.caption.color;
}, function (props) {
  return props.theme.form.padding;
}, _StyledButton.default, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.form.extra.buttonTextWeight;
});